// src/pages/Home_Page2.jsx

import React from "react";
import { motion } from "framer-motion";


const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.25,
    },
  },
};


const Home_Page2 = () => {
  return (
    <motion.div
      className="relative min-h-screen text-white overflow-hidden"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Dark gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(
              ellipse 80% 60% at 50% 35%,
              #4299e1 0%,
              rgba(66, 153, 225, 0.6) 25%,
              rgba(66, 153, 225, 0.3) 45%,
              rgba(30, 58, 138, 0.95) 70%,
              #1a202c 100%
            )
          `,
        }}
      />

      {/* Background image */}
        {/* Background video */}
        <video
          className="absolute inset-0 w-full h-full object-cover opacity-25"
          src="/vdo.mp4"
          autoPlay
          loop
          muted
          playsInline
        />



      {/* Main hero content */}
      <motion.main
        className="relative z-10 flex flex-col items-center justify-center text-center px-4 md:px-10 min-h-[calc(100vh-80px)]"
      >
        <motion.p
          className="mb-4 text-xs md:text-sm tracking-[0.35em] uppercase"
        >
          Delivering solutions
        </motion.p>

        <motion.h1
          className="max-w-5xl text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-wide"
        >
          SKYLINE MEP CONSULTANTS
        </motion.h1>
        <motion.p
          className="mt-2 md:mt-4 text-base md:text-2xl lg:text-2xl font-medium tracking-wide"
          style={{ letterSpacing: '0.08em' }}
        >
          Built on Teamwork & Driven by Expertise
        </motion.p>
      </motion.main>

      {/* Left vertical scroll text */}


      {/* Bottom contact bar */}
      <motion.footer
        className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4 px-6 md:px-16 py-4 bg-slate-900/60 backdrop-blur"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.6, ease: "easeOut" }}
      >
        <motion.div className="flex items-center gap-2" whileHover={{ x: 3 }}>
          <div className="flex h-9 w-9 items-center justify-center rounded-full border border-sky-400">
            <span className="text-lg">✈</span>
          </div>
          <a href="mailto:skylinemepconsultants@gmail.com" className="text-sm md:text-base tracking-wide">
            skylinemepconsultants@gmail.com
          </a>
        </motion.div>

        <motion.div className="flex items-center gap-2" whileHover={{ x: 3 }}>
          <div className="flex h-9 w-9 items-center justify-center rounded-full border border-sky-400">
            <span className="text-lg">📞</span>
          </div>
          <a href="tel:+919890621049" className="text-sm md:text-base tracking-wide">
            +91 9890621049
          </a>
        </motion.div>
      </motion.footer>
    </motion.div>
  );
};

export default Home_Page2;
